import { Logo } from "@/components/ui/Logo";
import type { Product } from "./productTheme";
import "./product.css";

export function ProductBrand({
  product = "bondoq",
  light = false,
  mark = false,
}: {
  product?: Product;
  light?: boolean;
  mark?: boolean;
}) {
  if (product === "rentinit")
    return (
      <Logo
        variant={mark ? "It" : "A"}
        tone={light ? "light" : "default"}
        style={{ height: mark ? 40 : 24, width: "auto", display: "block" }}
      />
    );
  return (
    <span
      className={`product-brand${light ? " product-brand-light" : ""}`}
      role="img"
      aria-label="Bondoq"
    >
      <img
        src={`/brand/bondoq-mark${light ? "-reversed" : ""}.svg`}
        alt=""
        width={mark ? 40 : 32}
        height={mark ? 40 : 32}
      />
      {!mark && <span aria-hidden="true">bondoq</span>}
    </span>
  );
}

export function ProductHeading({
  product = "bondoq",
  label,
}: {
  product?: Product;
  label: string;
}) {
  return (
    <div className="product-heading">
      <ProductBrand product={product} light />
      <span className="product-surface">{label}</span>
    </div>
  );
}
